export default __webpack_public_path__ + "static/media/splitsIcon.678e0e62.svg";